var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, } from 'react';
import InputWrapper from './input-wrapper';
const TextArea = forwardRef(function Input(_a, ref) {
    var { id, label, hideLabel, required, errorMessage } = _a, props = __rest(_a, ["id", "label", "hideLabel", "required", "errorMessage"]);
    return (_jsx(InputWrapper, { label: label, hideLabel: hideLabel, id: id, errorMessage: errorMessage, required: required, children: _jsx("textarea", Object.assign({}, props, { required: required, className: "form-control", id: id, ref: ref })) }));
});
export default TextArea;
